<template>
  <div class="h5content" id="scrollContent">
    <div class="consultingItem" v-for="row in list" :key="row.id">
      <div
        class="toptitle P-Cursor row flex-center"
        :class="!row.isOpen ? 'nb' : ''"
        @click="openCLoseFollow(row)"
      >
        <i class="iconfont icon-sanjiao" :class="row.isOpen ? 'open' : ''"></i>
        <div class="flex-1">
          {{ row.consultType == 1 ? "线上咨询" : "线下咨询" }}
        </div>
        <div
          class="typeTag"
          :class="getStatusClass(row)"
          v-if="row.statusStr && row.statusStr != ''"
        >
          {{ row.statusStr }}
        </div>
      </div>

      <div class="info" v-if="row.isOpen">
        <div class="infoitem row flex-center">
          <div class="flex-1 row flex-center">
            <div class="left">咨询时间:</div>
            <div class="flex-1 righttext">
              {{ $filters.formatDateTime(row.createTime) }}
            </div>
          </div>
        </div>

        <div class="infoitem row flex-center">
          <div class="flex-1 row flex-center">
            <div class="left">操作人:</div>
            <div class="flex-1 righttext">
              {{ row.createEmployeeName }}
            </div>
          </div>
        </div>

        <div class="infoitem row flex-center">
          <div class="left">咨询项目:</div>
          <div class="flex-1 righttext">
            {{ row.consultItemNames }}
          </div>
        </div>

        <div class="infoitem row flex-center" v-if="row.consultType == 1">
          <div class="left">沟通方式:</div>
          <div class="flex-1 righttext">
            {{ row.connectMethod }}
          </div>
        </div>

        <div class="infoitem row">
          <div class="left">咨询内容:</div>
          <div class="flex-1 righttext">
            {{ row.consultContent }}
          </div>
        </div>

        <div class="infoitem row">
          <div class="left">备注:</div>
          <div class="flex-1 righttext">
            {{ row.remark }}
          </div>
        </div>

        <div class="infoitem row">
          <div class="left">成交意愿:</div>
          <div class="flex-1 righttext">
            {{ row.transactIntent }}
          </div>
        </div>

        <div class="infoitem row">
          <div class="left">意向说明:</div>
          <div class="flex-1 righttext">
            {{ row.intentDesc }}
          </div>
        </div>

        <div class="infoitem row">
          <div class="left">跟进说明:</div>
          <div class="flex-1 righttext">
            {{ row.followDesc }}
          </div>
        </div>
      </div>
    </div>
    <EmptyImgh5 v-if="list.length == 0"></EmptyImgh5>
  </div>
</template>

<script>
import { patientConsultationList } from "@/api/patient.js";
import { userStore } from "@/store/user";

export default {
  name: "consultingInfo",
  props: [],
  components: {},
  data: function () {
    return {
      list: [],
    };
  },
  setup() {},
  mounted: function () {
    this.getList();
  },
  methods: {
    openCLoseFollow(row) {
      row.isOpen = !row.isOpen;
    },
    getStatusClass(row) {
      if (row.statusStr == "已执行") {
        return "success";
      }
    },
    getList() {
      //获取列表
      let that = this;
      const aloginStoreuth = userStore();
      patientConsultationList({
        corpId: aloginStoreuth.corpId,
        cusId: aloginStoreuth.cusId,
      }).then((res) => {
        let { data } = res.data;
        data.forEach((element, index) => {
          element.isOpen = false;
          if (index == 0) {
            element.isOpen = true;
          }
        });
        that.list = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.consultingInfo {
  background-color: #fff;
  padding: 20px;
  margin: 20px 0;
}

.consultingItem {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.083rem;
  margin-bottom: 15px;
}

.toptitle {
  font-size: 0.292rem;
  padding: 0.167rem 0.313rem;
  border-bottom: 1px solid #ededed;
  background: #f7f7f7;
  text-align: left;

  &.nb {
    border-bottom: none;
  }

  .icon-sanjiao {
    color: #999999;
    margin-right: 0.104rem;
    display: inline-block;
    position: relative;
    transition: all 0.3s;
    transform: rotate(-90deg);

    &.open {
      transform: rotate(0deg);
    }
  }

  .typeTag {
    font-size: 0.25rem;
    padding: 0.083rem 0.125rem;
    border-radius: 0.042rem;

    &.todo {
      background: #fff7e8;
      color: #faad14;
    }

    &.failed {
      background: #ffeded;
      color: #ff4d4f;
    }

    &.success {
      background: rgb(227, 251, 215);
      color: rgb(82, 196, 26);
    }

    &.gary {
      background: #ededed;
      /* 或者使用具体的灰色色值，比如 #808080 */
      color: #666;
      /* 同样可以使用具体的灰色色值 */
    }
  }
}

.info {
  padding: 0 0.25rem;
  padding-bottom: 0.208rem;

  .info-title {
    margin: 10px 0;
    text-align: left;
  }

  &.info-bottom {
    position: relative;

    &::before {
      content: "";
      width: 100%;
      height: 1px;
      left: 0;
      top: 0;
      background: #e6e6e6;
      display: inline-block;
    }
  }

  .infoitem {
    text-align: left;
    font-size: 0.292rem;
    margin-top: 0.25rem;

    .left {
      width: 1.792rem;
      color: #666;
    }

    .righttext {
      font-size: 0.292rem;
      color: #333;
    }
  }
}
</style>
